import React from "react";
import Container from "../../../Components/Container";
import OverviewImage from "../assets/OverviewBG@2x.png";

// const OverViewStyles = styled.div`
//   img {
//     width: 100%;
//     object-fit: cover;
//   }
// `;

const Overview = () => {
  return (
    <Container>
      <img
        alt="solar-storage-overview"
        className="no-drag"
        onClick={(e) => e.preventDefault()}
        style={{ width: "100%", objectFit: "cover" }}
        src={OverviewImage}
      />
    </Container>
  );
};

export default Overview;
